import { useMutation, useQueryClient } from "react-query";

import ClazzService from "../../services/Clazz";
import {Clazz} from "../../types";

import { QUERY_KEY } from "./useListClazzes";

function useJoinClazz(onSuccess?: (syllabus: Clazz) => void) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ code }: { code: string }) => ClazzService.joinClazz(code),
    {
      onSuccess: (syllabus) => {
        queryClient.invalidateQueries(QUERY_KEY);
        onSuccess?.(syllabus);
      },
    }
  );
}

export default useJoinClazz;
